import { AuthState } from '../../types';

const state: AuthState = {
  data: {
    accessToken: '',
    expiresIn: 0,
    tokenType: '',
    user: {
      businessType: '',
      email: '',
      uuid: '',
      name: '',
      organization: '',
      phone: '',
    },
  },
  login: {
    email: '',
    password: '',
  },
  changePassword: {
    new: '',
    confirm: '',
  },
};

export default state;
